import React, { lazy } from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'
import CashReceived from '@/views/AccountReceivable/CashReceived/index'
const accountReceivableRouter = [
  {
    path: "/AccountReceivable",
    element: <SandBox />,
    children: [
      {
        path: "CashReceived",
        element: docLazyFn(<CashReceived />),
      }
    ],
  }
];

export default accountReceivableRouter;
